import signUp from './signUp';
import cart, { paymentMethod } from './cart';
import errors from './errors';
import { escapedCountry } from 'utils/transform';

export const commonText = {
  ok: 'Ok',
  save: 'Save',
  close: 'Close',
  cancel: 'Close',
  apply: 'Apply',
  errorTitle: 'Something went wrong',
};
export const uploadButton = {
  modalTitle: 'Confirm you are happy to delete this image',
  adminModalTitle: 'Confirm you are happy to delete this file',
  remove: 'Remove',
  browse: 'Browse',
  upload: 'Upload from computer',
};
const onboardingPanel = {
  takeAction: 'Take Action',
  panelHeader: 'Action required',
  panelText:
    'To comply with regulators we require additional information from you. Please review the status of your setup. You can continue to raise funds but you must complete your setup to receive payouts.',
};

export const login = {
  header1: 'Welcome back!',
  header2:
    'Securely sign in below to monitor your sales & manage your transactions.',

  email: 'Email address',
  password: 'Password',
  forgotPassword: 'Forgot password?',
  checkbox: 'Remember my login',

  submit: 'Sign In',
  notMatch:
    'Your email and / or password do not match our records. Please try again or ',
  requestPassword: 'request a forgot password link.',
  errors: {
    email: errors.email,
    password: errors.password,
  },
};

export const forgotPassword = {
  header1: 'Forgot your password?',
  header2: 'Request a password reset link below.',

  successHeader1: 'Check your email',
  successHeader2: (email) =>
    `We have sent an email to ${email || 'your email address'
    } if your account is in our database. You can reset your password using the link in the email.`,
  return: 'Return to sign in',
  goToEmail: 'Go to email',

  email: 'Email address',
  login: 'Login',

  submit: 'Reset Password',

  errors: {
    email: errors.email,
  },
};

export const resetPassword = {
  header1: 'Create new password',
  header2: 'Please, type your new password below',

  email: 'Email address',
  password: 'New password',
  password_confirmation: 'Confirm password',

  submit: 'Create password',

  errors: {
    email: errors.email,
    password: errors.password,
    password_confirmation: {
      match: 'Passwords do not match',
      required: 'Password confirmation is required',
    },
  },
};

export const fundraiserNew = {
  header1: 'Create Fundraiser',
  header2:
    'Enter your fundraiser details below. This will help donors understand your story and help you reach your target. As soon as your fundraiser is created you can share the link to start raising money straight away.',
  editHeader2: 'You can edit the details of your fundraiser below',

  name: 'Fundraiser name',
  goal: 'Fundraising goal',
  country: escapedCountry,
  city: 'City',
  description: 'Short Description',
  story: 'Tell your story',
  video: 'Video Embed',
  video_tooltip: 'Add the embed code from your video hosting platform.',
  image: 'Upload Image',
  amounts: 'Donation Amounts',

  image_tooltip:
    'Upload an image that represents your fundraiser. It must be in jpeg, jpg or png format and less than 1MB size.',

  errors: {
    name: errors.name.required,
    image: {
      required: 'Image is required',
      max: 'Uploaded file is too large. Image size should be max 1MB',
      type: 'This file type is not supported. Please upload jpeg, jpg or png image.',
    },
    goal: 'Goal is required',
    description: 'Short description is required',
    city: errors.city.required,
    country: errors.country.required,
    amount: {
      required: 'Donation amount is required',
      min: 'Minumum donation amount is 3.00',
    },
  },

  leavePrompt:
    'If you navigate way from this page, your changes will not be saved.',
  editCTA: 'Save Changes',
  submit: 'Create Fundraiser',
};

export const productNew = {
  header1: 'Create Product or Service',
  header2:
    'Generate a link to request payment, or copy the code to your website to start selling immediately',

  image: 'Product image',
  fitPhoto: 'Fit photo to container',
  name: 'Product name',
  video: fundraiserNew.video,
  video_tooltip: fundraiserNew.video_tooltip,
  price: 'Price',
  vatSubtitle: 'Enter price inclusive of VAT',
  vatExclusive: 'Show price as VAT exclusive',
  vatRate: 'Vat Rate %',
  description: 'Description',
  availableStock: 'Stock Limit',
  availableStockSubtitle:
    "Enter a stock limit if applicable or leave at 0 for 'Out of Stock'",
  autoAccept: 'Auto accept orders',
  requestInformation: 'Request delivery information from buyer',
  image_tooltip: fundraiserNew.image_tooltip,

  errors: {
    name: 'Product name is required',
    image: 'Product image is required',
    price: 'Price is required',
    description: 'Description is required',
    vatRate: {
      min: 'Vat rate cannot be less than 0',
      max: 'Vat rate cannot be more than 100',
    },
  },

  buyNow: 'Buy Now',
  submit: 'Create Product',
};
export const productList = {
  header1: 'Javelin Store',
  header2:
    'Hassle-free selling. Create a product, or service in one step. Copy the product card and Buy Button to your website, or send the payment link via Javelin send, using email or sms',
  create: 'Create Product',

  copy: 'COPY',
  clone: 'Clone Product',
  getLink: 'Get Link',
  getCode: 'Get Embed Code',
  txtpayShare: 'Txtpay Share',
  share: 'Share',
  edit: 'EDIT',

  linkInfo: 'Ideal for social sharing, on facebook, instagram, or whatsapp',
};
export const txtPay = {
  header: 'Txtpay',
  subtitle: 'Send your product to your customer now by sms, or email',
  choose: 'Choose Channel',
  email: 'Email',
  sms: 'SMS',
  customerDetails: 'Customer Details',
  name: 'First name',
  lastName: 'Surname',
  phone_number: 'Phone',
  content: 'Personalised Message',
  submit: 'SEND',

  errors: {
    email: errors.email,
    phone_number: errors.phone_number,
    first_name: {
      required: 'First name is required',
    },
    last_name: {
      required: 'Surname is required',
    },
    content: {
      required: 'Personalised message is required',
    },
  },
};
export const embedCode = {
  header: 'Embed Code',
  subtitle: 'Include the following script in the ',
  step1: `Include the following script in the&nbsp;<code>&lt;body&gt;</code>
  &nbsp;above any other JavaScript on your website.`,
  step2:
    'Copy this code and paste anywhere on your website, where you want the checkout panel to be rendered on the page.',
};
export const fundraiserList = {
  emptyHeader1: 'Kick start your fundraising campaign.',
  emptyHeader2: 'To start accepting donations create your fundraiser below.',
  header1: 'Your fundraisers',
  header2:
    'Below you can see your fundraisers.  From here you can edit your fundraiser, set it live, deactivate it and even change your target.',

  create: 'Create Fundraiser',
  createFirst: 'Create your first fundraiser',
  createFirstSubtitle:
    'You can receive donations to your cause in a few easy steps',

  copy: 'COPY',
  clone: 'Clone Fundraiser',
  getLink: 'Get Link',
  getCode: 'Get Button Code',
  share: 'Share',
  linkInfo: 'Ideal for social sharing, on facebook, instagram, or whatsapp',
  ...onboardingPanel,
};

export const orderList = {
  header1: 'Donations',
  header2: 'View all of your donations, payment status and donor details.',

  noFundraiserHeader1: 'Start collecting donations in a few simple steps.',
  noFundraiserHeader2:
    'You can start raising funds for your cause, once you create your first fundraiser.',

  emptyHeader1: 'You have no donations yet',
  emptyHeader2:
    'Ask your family and friends to donate to your cause and help kick start your fundraising.',
  noLiveHeader2:
    'Set your fundraiser live to start collecting funds now.  It’s quick and simple',

  create: fundraiserList.create,
  createFirst: fundraiserList.createFirst,
  createFirstSubtitle: fundraiserList.createFirstSubtitle,
  go: 'Go to Fundraisers',

  orderId: 'Order ID',
  productName: 'Product Name',
  email: 'Email',
  phone: 'Phone',
  total: 'Total',
  status: 'Status',
  date: 'Paid Date',
  sent: 'Sent',
  exportHeader: 'Export Orders',
  ...onboardingPanel,
};

export const orderDetail = {
  header1: 'Donation Details',
  header2: 'Review donation details below',

  buyer: 'Buyer Details',
  shipment: 'Shipment Details',
  trackingNo: 'Tracking Number',
  shipOrder: 'Ship Order',
  acceptOrder: 'Accept Order',
  rejectOrder: 'Reject Order',
  sendReceipt: 'Resend Receipt',
  complete: 'Mark Delivered',
};

export const profile = {
  email: 'Email address',
  password: 'Password',
  first_name: 'First Name',
  last_name: 'Surname',
  phone: 'Phone',

  update: 'Update',

  errors: {
    email: {
      invalid: errors.email.invalid,
    },
    password: {
      min: errors.password.min,
    },
    phone: {
      invalid: errors.phone_number.invalid,
    },
  },
};

export const navbar = {
  fundraisers: 'Fundraisers',

  payments: 'Payments',
  disputeFlow: 'Dispute Flow',
  billing: 'Billing',
  caboodle: 'Caboodle',
  admin: 'Admin',

  settings: 'Settings',
  signOut: 'Sign Out',
};

export const notification = {
  dismiss: 'Dismiss',
};

export const welcome = {
  header1: (name) => `Welcome to ${name || 'Hailopay'}`,
  header1Sub: 'powered by Javelin Payments',
  header2: 'To start accepting donations, create your fundraiser below.',
  header2HasFundraiser: 'You can see the status of your set up below.',

  step1: 'Step 1:',
  complete: ' Complete setup',
  step1Subtitle:
    'To comply with regulatory requirements we must verify your identity to complete your setup. The review of your details can take 2-5 working days. You have 30 days to complete this process or all donations will be refunded in-line with regulations. The status of your set up is below.',
  cta1: 'Complete Setup',

  createFirst: fundraiserList.createFirst,
  step2: 'Step 2:',
  step2Subtitle: 'You can receive donations to your cause in a few easy steps',
  cta2: 'Create Fundraiser',

  payoutsSubtitle:
    'Verification takes 2-5 business days. Your store can accept payments while you await approval. If you do not set up your payouts within 30 days of the date of your first payments received, all payments will be refunded to your customers.',
  approved: 'Good news! Your profile has been approved',
  dismiss: 'Dismiss',
};
export const newCompany = {
  header1: (name) => welcome.header1(name),
  poweredBy: welcome.header1Sub,
  header2:
    'To comply with regulatory requirements, Javelin must verify your identity to complete set up.  Once you have completed the form below, you will be ready to progress to setting up payouts to your bank account.',
  readyHeader1: 'Great, you are now ready to set up your payouts.',
  submitting:
    'Please <b>do not press back</b> while we securely transfer your details to payment processor, Adyen.',
  submitInfo:
    'You will be redirected in one moment, to complete your profile. ',
  securely: 'We’re securely transferring your details to Adyen',
  formHeader1: 'Account owner information:',
  formSubheader1:
    'In other words the status of the bank account owner. Accounts can belong to a business, an individual, or a non-profit organisation.',

  formHeader2: 'Contact Information:',
  formSubheader2:
    'Please enter the payee contact details. This information will not be used to contact you but is required by our payment partners to verify your payouts.',

  types: {
    individual: 'Individual',
    nonProfit: 'NonProfit',
    business: 'Business',
  },

  legal_entity: 'Type',
  industry: 'Industry',
  legal_business_name: 'Registered Company Name',
  organisation_name: 'Registered Organisation Name',
  authorized_payee: 'Authorized Payee Name',
  store_name: `Company Name \n(trading as)`,

  first_name: 'First Name',
  last_name: 'Surname',

  country: escapedCountry,

  type_tooltip:
    'Choose the account type you would like to set up, an individual, a business entity or a registered charity / not for profit organisation.',
  store_name_tooltip:
    'This is how you will be identified to the shopper at checkout. The name will also appear on their bank statement. This could be your brand name, fundraiser name or how you identify as a trader.',
  legal_entity_placeholder: 'Select an account type',
  industry_placeholder: 'Select from dropdown',

  // common
  contact_name: 'Contact Name',
  email: 'Email',
  phone_number: 'Phone',

  submit: 'Continue',

  errors: {
    email: errors.email,
    phone_number: errors.phone_number,
    first_name: {
      required: 'First name is required',
    },
    last_name: {
      required: 'Surname is required',
    },
    country: errors.country,
    city: errors.city,
    legal_entity: {
      required: 'Account type is required',
    },
    legal_business_name: {
      required: 'Registered company name is required',
    },
    industry: {
      required: 'Industry is required',
    },
    store_name: {
      required: 'Company name (trading as) is required',
    },
  },
};

export const notFound = {
  header1: '404',
  header2: 'Page Not Found',
  link: 'HOME PAGE',
};
export const orderSuccess = {
  header1: (nonFundraiser) => `Thank you for your ${nonFundraiser ? 'payment' : 'donation'}`,
  defaultError: paymentMethod.defaultError,
  shippingDetails: 'Shipping Details',
  manyCauses: 'There are many causes that need your support, check them out.',
  shareOnSocial: (name) =>
    `You can really help ${name || 'this fundraiser'
    } by spreading the word on social media. Share your donation now`,
  browse: 'Browse Fundraisers',
  terms: 'Terms & Conditions',
  total: 'Total',
  subtotal: 'Subtotal',
  shipping: 'Shipping',
  vat: 'VAT',
  fees: 'Fees',
  tax: 'Tax',
};
export const insights = {
  header1: 'Fundraiser Insights',
  header2: 'A summary of your fundraising activity below.',
  totalRaised: 'You have raised ',
  donations: {
    title: 'Donations',
    recent: 'Recent Donations',
    view: 'View all donations',
    top: 'Top Donor',
    average: 'Average Donation Amount',
  },
  fundraisers: {
    title: 'Active Fundraisers',
    view: 'View all fundraisers',
  },
  raised: 'raised',
  goal: 'goal',
  noActiveFundraisers: {
    text: 'To see your active fundraisers displayed here, you need to set your',
    live: ' fundraiser live ',
    or: 'or',
    create: ' create a fundraiser.',
  },
};

export const exportModal = {
  title: 'Export Payments',
  titleSuccess:
    'Your request has been completed. \n Check your email shortly for access to the file.',
  message:
    'This file will include all the parameters you have active in your current search results and emailed directly to you.',
  export: 'Export',
  exporting: 'Exporting',
  ...commonText,
};
export const table = {
  showing: (count, total) =>
    `Showing ${count || 0} ${count === 1 ? 'result' : 'results'} of ${total || 0
    }`,
  perPage: 'Results per page:',
};
export const paymentFilter = {
  status: 'Status',
  amount: 'Amount',
  fraud: 'Fraud Score',
  reason: 'Reason',
  apply: commonText.apply,
};
export const CompanyNew = {
  header: 'Create Company',
  cancel: 'Cancel',
  display_name: 'Display Name',
  legal_business_name: 'Legal Business Name',
  first_name: 'First Name',
  last_name: 'Last Name',
  email: 'Email',
  phone_number: 'Phone Number',
  country: 'Country',
  legal_entity: 'Legal Entity',
  legal_entity_options: [
    { value: 'Business', label: 'Business' },
    { value: 'Individual', label: 'Individual' },
    { value: 'NonProfit', label: 'NonProfit' },
  ],
  shortcode: 'Shortcode',
  mcc_code: 'Merchant Category Code',
  google_pay_merchant_id: 'Google Pay Merchant ID',
  checkout_logo: 'Checkout Logo',
  account_holder_code: 'Account Holder Code',
  stripe_account_id: 'Stripe Account ID',
  client_id: 'Client',
  fee_structure_id: 'Fee Structure',
  integration_id: 'Integration',
  caboodle_fleet: 'Caboodle Fleet',
  errors: {
    display_name: 'Display name is required',
    legal_business_name: 'Legal business name is required',
    first_name: 'First name is required',
    last_name: 'Last name required',
    email: errors.email.required,
    phone_number: 'Phone number is required',
    country: errors.country.required,
    legal_entity: 'Legal Entity is required',
    checkout_logo: {
      max: 'Uploaded file is too large. Image size should be max 1MB',
      type: 'This file type is not supported. Please upload jpeg, jpg or png image.',
    },
    client_id: 'Client is required',
    mcc_code: 'Merchant Category code is required',
  },
};

export default {
  signUp,
  commonText,
  login,
  productNew,
  fundraiserNew,
  productList,
  fundraiserList,
  orderList,
  orderDetail,
  profile,
  navbar,
  notification,
  welcome,
  notFound,
  cart,
  CompanyNew,
};
